import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield, Zap, Lock, DollarSign } from 'lucide-react';

const RiskFreeGuarantees = () => {
  const { t } = useTranslation();

  const guarantees = [
    {
      id: 1,
      icon: <DollarSign className="w-6 h-6" />,
      emoji: '💰',
      titleKey: 'riskFreeGuarantees.guarantees.moneyBack.title',
      descKey: 'riskFreeGuarantees.guarantees.moneyBack.desc',
      gradient: 'from-green-500 to-emerald-500'
    },
    {
      id: 2,
      icon: <Zap className="w-6 h-6" />,
      emoji: '⚡',
      titleKey: 'riskFreeGuarantees.guarantees.uptime.title',
      descKey: 'riskFreeGuarantees.guarantees.uptime.desc',
      gradient: 'from-blue-500 to-cyan-500'
    },
    {
      id: 3,
      icon: <Shield className="w-6 h-6" />,
      emoji: '🛡️',
      titleKey: 'riskFreeGuarantees.guarantees.security.title',
      descKey: 'riskFreeGuarantees.guarantees.security.desc',
      gradient: 'from-purple-500 to-violet-500'
    }
  ];



  return (
    <section className="py-20 lg:py-28 bg-gradient-to-br from-green-50/50 via-white to-emerald-50/50 relative overflow-hidden">
      {/* 装饰性背景元素 */}
      <div className="absolute -top-20 -right-20 w-80 h-80 bg-green-100 rounded-full opacity-20 blur-3xl"></div>
      <div className="absolute top-40 -left-32 w-64 h-64 bg-emerald-100 rounded-full opacity-15 blur-2xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* 标题部分 */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-gradient-to-r from-green-100 to-emerald-100 text-green-600 rounded-full px-6 py-3 text-sm font-semibold mb-8">
            <Shield className="w-4 h-4 mr-2" />
            {t('riskFreeGuarantees.badge')}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            {t('riskFreeGuarantees.headline')}
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('riskFreeGuarantees.subtitle')}
          </p>
        </div>

        {/* 保证承诺 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {guarantees.map((guarantee) => (
            <div
              key={guarantee.id}
              className="bg-white rounded-3xl border border-gray-100 p-8 hover:shadow-2xl transition-all duration-300 group relative overflow-hidden text-center"
            >
              {/* 装饰性背景 */}
              <div className={`absolute -top-16 -right-16 w-32 h-32 bg-gradient-to-r ${guarantee.gradient} rounded-full opacity-5 blur-2xl group-hover:opacity-10 transition-opacity duration-300`}></div>
              
              <div className="relative z-10">
                {/* 图标 */}
                <div className="flex items-center justify-center mb-6">
                  <div className={`w-16 h-16 bg-gradient-to-r ${guarantee.gradient} rounded-2xl flex items-center justify-center text-white shadow-lg group-hover:scale-110 transition-transform duration-300 mr-3`}>
                    {guarantee.icon}
                  </div>
                  <span className="text-3xl">{guarantee.emoji}</span>
                </div>

                {/* 标题和描述 */}
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {t(guarantee.titleKey)}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {t(guarantee.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default RiskFreeGuarantees;